import type { DropdownMenuItem } from '@nuxt/ui';
import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import { useI18n } from 'vue-i18n';

export interface UseRevertMenuItemOptions {
	dirty: MaybeRefOrGetter<boolean | undefined>;
	disabled?: MaybeRefOrGetter<boolean | undefined>;
	onRevert: () => void;
}

export function useRevertMenuItem(options: UseRevertMenuItemOptions): ComputedRef<DropdownMenuItem | null> {
	const { t } = useI18n();

	return computed(() => {
		if (!toValue(options.dirty)) return null;

		return {
			label: t('common.revert_change'),
			icon: 'lucide:undo-2',
			disabled: toValue(options.disabled),
			onSelect: options.onRevert,
		};
	});
}
